<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>

        <div class="d-sm-flex d-none user-nav" v-if="get(user, 'info.email')">
            <p class="user-name font-weight-bolder mb-0">
                <template v-if="get(user, 'info.full_name') && get(user, 'info.full_name') !== ''">
                    {{get(user, 'info.full_name')}}
                </template>
                <template v-else>
                    {{get(user, 'info.username')}}
                </template>
            </p>
            <small class="text-muted">{{ get(user, 'info.username') }}</small>
        </div>
        <b-overlay
            variant="white"
            :show="loading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
          >
              <b-avatar
                size="40"
                :src="get(user, 'info.avatar')"
                :text="avatarText(get(user, 'info.email', 'No data'))"
                variant="light-primary"
                badge
                class="badge-minimal"
                badge-variant="success"
              >
                <feather-icon
                  v-if="!get(user, 'info.email')"
                  icon="UserIcon"
                  size="22"
                />
              </b-avatar>
        </b-overlay>
    </template>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Выйти</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
  import { ref, onMounted } from '@vue/composition-api'

import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BOverlay
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import store from '@/store'
import get from 'lodash.get'

  export default {

      components: {
          BNavItemDropdown,
          BDropdownItem,
          BDropdownDivider,
          BAvatar,
          BOverlay
      },


      setup () {

          const user = ref()
          const loading = ref(false)


          onMounted( async () => {
              loading.value = true
              if (!store.getters['auth/getAppActiveUser'])
                  await store.dispatch('auth/fetchUser').catch(()=>{})
              user.value = store.getters['auth/getAppActiveUser']
              loading.value = false
          })

          const logout = () => store.dispatch('auth/logout')

          return {
              user,
              logout,
              avatarText,
              get,
              loading
          }
      }
}
</script>
